"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = makeAuthGetters;
function makeAuthGetters() {
  return {
    // Auth specific "Getters" will go here
  };
}
module.exports = exports.default;